function ProviderToggle({ c, dark, aiProvider, setAiProvider }) {
  const optionStyle = (provider) => ({
    background: aiProvider === provider
      ? (provider === "openai" ? (dark ? "#0d2137" : "#ebf8ff") : (dark ? "#2d2010" : "#fffbeb"))
      : "transparent",
    color: aiProvider === provider
      ? (provider === "openai" ? (dark ? "#63b3ed" : "#2b6cb0") : (dark ? "#f6ad55" : "#b45309"))
      : c.textSecondary,
    border: "none",
    borderRight: provider === "openai" ? `1px solid ${c.border}` : "none",
    cursor: "pointer",
    padding: "5px 10px",
    fontSize: 11,
    fontWeight: 700,
  });

  return (
    <div role="group" aria-label="AI Provider" style={{ display: "inline-flex", alignItems: "center", border: `1px solid ${c.border}`, borderRadius: 999, overflow: "hidden" }}>
      <button type="button" onClick={() => setAiProvider("openai")} style={optionStyle("openai")} aria-pressed={aiProvider === "openai"}>
        OpenAI
      </button>
      <button type="button" onClick={() => setAiProvider("anthropic")} style={optionStyle("anthropic")} aria-pressed={aiProvider === "anthropic"}>
        Claude
      </button>
    </div>
  );
}

const accountMenuButtonStyle = (c, { active = false, danger = false } = {}) => ({
  width: "100%",
  minHeight: 34,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  padding: "7px 10px",
  borderRadius: 7,
  border: `1px solid ${danger ? "rgba(252,129,129,.42)" : active ? c.success : c.border}`,
  background: danger ? "rgba(204,51,51,.16)" : active ? "rgba(72,187,120,.12)" : c.bg,
  color: danger ? c.danger : active ? c.success : c.textSecondary,
  cursor: "pointer",
  fontSize: 12,
  fontWeight: 700,
  fontFamily: "inherit",
  boxSizing: "border-box",
});

export default function AppHeader({
  c,
  dark,
  aiProvider,
  setAiProvider,
  resetApp,
  headerLogoSrc,
  session,
  isAdmin,
  isDemoUser,
  onSignOut,
  setIsDarkTheme,
  visibleTabs,
  activeTab,
  setActiveTab,
}) {
  const roleTone = isAdmin ? "primary" : "warning";
  const handleHomeClick = () => {
    resetApp();
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "12px 22px 0",
        borderBottom: `1px solid ${c.border}`,
        background: c.bgSecondary,
        boxShadow: dark ? "0 4px 14px rgba(0,0,0,.3)" : "0 4px 14px rgba(15,23,42,.08)",
      }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", gap: 14, marginBottom: 10, width: "100%", position: "relative" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <ProviderToggle c={c} dark={dark} aiProvider={aiProvider} setAiProvider={setAiProvider} />
        </div>

        <button
          type="button"
          onClick={handleHomeClick}
          style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", background: "transparent", border: "none", color: c.text, padding: 0 }}
          title="Zur Startseite"
        >
          <img
            src={headerLogoSrc}
            alt=""
            style={{ width: 30, height: 30, borderRadius: 7, objectFit: "cover", border: `1px solid ${c.border}` }}
          />
          <span style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <span style={{ fontWeight: 700, fontSize: 22, lineHeight: 1.1 }}>RadVentura</span>
            <span style={{ fontSize: 11, color: c.textSecondary }}>AI-enhanced radiology reporting</span>
          </span>
        </button>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, flexWrap: "wrap" }}>
          <details style={{ position: "relative" }}>
            <summary
              aria-label="Account"
              title={session?.user?.email || "Account"}
              style={{
                listStyle: "none",
                cursor: "pointer",
                color: c.textSecondary,
                border: `1px solid ${c.border}`,
                borderRadius: 999,
                padding: "5px 10px",
                fontSize: 12,
                fontWeight: 700,
                background: c.bg,
                userSelect: "none",
              }}
            >
              Account
            </summary>
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "calc(100% + 6px)",
                zIndex: 50,
                display: "flex",
                flexDirection: "column",
                gap: 6,
                minWidth: 260,
                padding: 12,
                background: c.bg,
                border: `1px solid ${c.border}`,
                borderRadius: 10,
                boxShadow: dark ? "0 12px 30px rgba(0,0,0,.45)" : "0 12px 28px rgba(15,23,42,.14)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "2px 2px 8px", borderBottom: `1px solid ${c.border}` }}>
                <div style={{ fontSize: 12, color: c.textSecondary, wordBreak: "break-word", minWidth: 0 }}>{session?.user?.email}</div>
                <span style={{ flexShrink: 0, fontSize: 10, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: roleTone === "primary" ? c.success : c.warning, border: `1px solid ${roleTone === "primary" ? c.success : c.warning}`, borderRadius: 999, padding: "3px 7px", background: roleTone === "primary" ? "rgba(72,187,120,.12)" : "rgba(246,216,96,.12)" }}>
                  {isAdmin ? "Admin" : "User"}
                </span>
              </div>
              {isDemoUser && (
                <div style={{ fontSize: 11, color: c.textSecondary, padding: "4px 2px" }}>
                  Demo-Konto
                </div>
              )}
              {isAdmin && (
                <button
                  type="button"
                  onClick={() => setActiveTab("freigaben")}
                  style={accountMenuButtonStyle(c, { active: activeTab === "freigaben" })}
                >
                  <span>Freigaben</span>
                  <span style={{ fontSize: 13 }}>›</span>
                </button>
              )}
              <div style={{ borderTop: `1px solid ${c.border}`, marginTop: 4, paddingTop: 8 }}>
                <button type="button" onClick={onSignOut} style={accountMenuButtonStyle(c, { danger: true })}>
                  <span>Abmelden</span>
                </button>
              </div>
            </div>
          </details>
          <button
            type="button"
            onClick={() => setIsDarkTheme((value) => !value)}
            aria-label={dark ? "Helles Design aktivieren" : "Dunkles Design aktivieren"}
            title={dark ? "Helles Design aktivieren" : "Dunkles Design aktivieren"}
            style={{
              background: dark ? "#2d3748" : "#e2e8f0",
              border: "none",
              borderRadius: 20,
              width: 34,
              height: 30,
              cursor: "pointer",
              fontSize: 16,
              color: dark ? "#f8fafc" : "#0f172a",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {dark ? "☀" : "☾"}
          </button>
        </div>

      </div>

      <nav role="tablist" aria-label="Hauptbereiche" style={{ display: "flex", gap: 2, maxWidth: "100%", overflowX: "auto" }}>
        {visibleTabs.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={activeTab === key}
            onClick={() => setActiveTab(key)}
            style={{
              background: activeTab === key ? c.bg : "none",
              border: "none",
              cursor: "pointer",
              padding: "8px 14px",
              fontSize: 13,
              borderRadius: "6px 6px 0 0",
              color: activeTab === key ? c.text : c.textSecondary,
              fontWeight: activeTab === key ? 700 : 500,
              display: "inline-flex",
              alignItems: "center",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </button>
        ))}
      </nav>
    </header>
  );
}
